export default "__VITE_ASSET__Cxtt9tPQ__"